import APIClient from './index';

export const getKeyMomentTypes = () =>
  new Promise((resolve, reject) =>
    APIClient.get(`/key-moment-types`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error?.response?.data))
  );
